module.exports = __webpack_public_path__ + "static/img/Maria.98d5628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Maria.png
// module id = Ch34
// module chunks = 1